import { type HighlightsController } from '@databases/highlights';
import { createHighlightsEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface HighlightsEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createHighlightsEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.HIGHLIGHTS_EFFECT,
    type: 'effect',
    isEnabled: (ctx) => ctx.layoutType === DatabaseLayoutType.TABLE,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createHighlightsEffect(highlightsController);
    },
  };
}
